import React, { ChangeEvent, useEffect, useState } from "react";
import { CheckBox, Datepicker, SelectDropdown, TextareaCount } from "./Inputs";
import { useSelectorsCountriesQuery } from "../../../hooks/useSelectorsQuery";
import { Country } from "../../../types/geo";

interface SaveProps {
    onSave: (value: any) => void
}

interface ChangeProps {
    onChange: (value: any) => void
}

interface ComplexClaimProps {
    without_hotel?: boolean | null,
    hotel_wishes?: string,
    details?: string,
    comments?: string,
}

interface ComplexClaimEditProps extends ComplexClaimProps, ChangeProps {
}

export const ComplexClaimDetails = ({ details }: ComplexClaimProps) => {
    return (
        <div className="flex w-full p-5 items-start gap-5 relative flex-[0_0_auto]">
            <div className="flex flex-col w-full items-start gap-1 relative">
                <div
                    className="w-full text-[#949494] text-[length:var(--client-acrom-ph1-16-medium-acrom-font-size)] leading-[var(--client-acrom-ph1-16-medium-acrom-line-height)] relative font-client-acrom-ph1-16-medium-acrom font-[number:var(--client-acrom-ph1-16-medium-acrom-font-weight)] tracking-[var(--client-acrom-ph1-16-medium-acrom-letter-spacing)] [font-style:var(--client-acrom-ph1-16-medium-acrom-font-style)]">
                    Детали командировки
                </div>
                <p className="w-full text-black text-[length:var(--manager-acrom-ph1-16-medium-acrom-font-size)] leading-[var(--manager-acrom-ph1-16-medium-acrom-line-height)] relative font-manager-acrom-ph1-16-medium-acrom font-[number:var(--manager-acrom-ph1-16-medium-acrom-font-weight)] tracking-[var(--manager-acrom-ph1-16-medium-acrom-letter-spacing)] [font-style:var(--manager-acrom-ph1-16-medium-acrom-font-style)]">
                    {details}
                </p>
            </div>
        </div>
    );
}

export const ComplexClaimWishlist = ({ hotel_wishes }: ComplexClaimProps) => {
    return (
        <div className="flex w-full p-5 items-start gap-5 relative flex-[0_0_auto]">
            <div className="flex flex-col w-full items-start gap-1 relative">
                <div
                    className="w-full text-[#949494] text-[length:var(--client-acrom-ph1-16-medium-acrom-font-size)] leading-[var(--client-acrom-ph1-16-medium-acrom-line-height)] relative font-client-acrom-ph1-16-medium-acrom font-[number:var(--client-acrom-ph1-16-medium-acrom-font-weight)] tracking-[var(--client-acrom-ph1-16-medium-acrom-letter-spacing)] [font-style:var(--client-acrom-ph1-16-medium-acrom-font-style)]">
                    Комментарии
                </div>
                <div
                    className="relative w-full font-manager-acrom-ph1-16-medium-acrom font-[number:var(--manager-acrom-ph1-16-medium-acrom-font-weight)] text-black text-[length:var(--manager-acrom-ph1-16-medium-acrom-font-size)] tracking-[var(--manager-acrom-ph1-16-medium-acrom-letter-spacing)] leading-[var(--manager-acrom-ph1-16-medium-acrom-line-height)] [font-style:var(--manager-acrom-ph1-16-medium-acrom-font-style)]">
                    {hotel_wishes}
                </div>
            </div>
        </div>
    );
};

export const ComplexClaimHotelNeededEdit = ({ without_hotel, onChange }: ComplexClaimEditProps) => {

    const [checked, setChecked] = useState<boolean>(!!without_hotel);

    const handleChecked = (value: boolean) => {
        onChange(value);
        setChecked(value);
    }
    return (
        <div className="inline-flex items-center gap-2.5 relative flex-[0_0_auto]">
            <CheckBox checked={checked} onChange={handleChecked} />
            <div
                className="w-full text-black text-[length:var(--manager-acrom-ph1-16-medium-acrom-font-size)] leading-[var(--manager-acrom-ph1-16-medium-acrom-line-height)] relative font-manager-acrom-ph1-16-medium-acrom font-[number:var(--manager-acrom-ph1-16-medium-acrom-font-weight)] tracking-[var(--manager-acrom-ph1-16-medium-acrom-letter-spacing)] [font-style:var(--manager-acrom-ph1-16-medium-acrom-font-style)]">
                Отель не нужен
            </div>
        </div>
    );
}

export const ComplexClaimWishlistEdit = ({ hotel_wishes, without_hotel, onChange }: ComplexClaimEditProps) => {
    const [text, setText] = useState<string>(hotel_wishes || '');

    const handleChange = (e: ChangeEvent<HTMLTextAreaElement>) => {
        if (e.target.value.length <= 500) {
            setText(e.target.value);
            onChange(e.target.value);
        }
    };

    useEffect(() => {
        if (without_hotel) {
            setText('');
            onChange('');
        }
    }, [without_hotel]);

    return (
        <div className="inline-flex flex-col w-full items-start gap-2 relative flex-[0_0_auto]">
            <div className="w-full flex flex-row text-[#949494] text-[length:var(--manager-acrom-ph-14-medium-acrom-font-size)] leading-[var(--manager-acrom-ph-14-medium-acrom-line-height)] relative font-manager-acrom-ph-14-medium-acrom font-[number:var(--manager-acrom-ph-14-medium-acrom-font-weight)] tracking-[var(--manager-acrom-ph-14-medium-acrom-letter-spacing)] [font-style:var(--manager-acrom-ph-14-medium-acrom-font-style)]">
                Комментарии {!without_hotel && <div className="text-red-500">*</div>}
            </div>
            <TextareaCount
                text={text}
                readOnly={!!without_hotel} // Без отеля - ввод в поле отключен
                handleChange={handleChange}
            />
        </div>
    );
}

export const ComplexClaimDetailsEdit = ({ details, onChange }: ComplexClaimEditProps) => {
    const [text, setText] = useState<string>(details || '');

    const handleChange = (e: ChangeEvent<HTMLTextAreaElement>) => {
        if (e.target.value.length <= 2000) {
            setText(e.target.value);
            onChange(e.target.value);
        }
    };

    return (
        <div className="inline-flex w-full flex-col mb-5 px-5 items-start gap-2 relative flex-[0_0_auto]">
            <div className="w-full flex flex-row text-[#949494] text-[length:var(--manager-acrom-ph-14-medium-acrom-font-size)] leading-[var(--manager-acrom-ph-14-medium-acrom-line-height)] relative font-manager-acrom-ph-14-medium-acrom font-[number:var(--manager-acrom-ph-14-medium-acrom-font-weight)] tracking-[var(--manager-acrom-ph-14-medium-acrom-letter-spacing)] [font-style:var(--manager-acrom-ph-14-medium-acrom-font-style)]">
                Детали командировки <div className="text-red-500">*</div>
            </div>
            <TextareaCount max={2000} text={text} handleChange={handleChange} />
        </div>
    );
}


interface VisaProps {
    entry_date?: string | null,
    departure_date?: string | null,
    comment?: string
    country?: Country | null
}

interface VisaEditProps extends VisaProps, ChangeProps {
}

export const VisaEntryDate = ({ entry_date, departure_date }: VisaProps) => {
    return (
        <div className="w-1/4 items-start gap-1 inline-flex flex-col">
            <div
                className="w-full relative mt-[-1.00px] font-manager-acrom-ph1-16-medium-acrom font-[number:var(--manager-acrom-ph1-16-medium-acrom-font-weight)] text-black text-[length:var(--manager-acrom-ph1-16-medium-acrom-font-size)] tracking-[var(--manager-acrom-ph1-16-medium-acrom-letter-spacing)] leading-[var(--manager-acrom-ph1-16-medium-acrom-line-height)] [font-style:var(--manager-acrom-ph1-16-medium-acrom-font-style)]">
                {entry_date ? new Date(entry_date).toLocaleDateString() : '-'}
            </div>
            <div
                className="w-full text-[#949494] text-[length:var(--manager-acrom-ph-14-medium-acrom-font-size)] leading-[var(--manager-acrom-ph-14-medium-acrom-line-height)] relative font-manager-acrom-ph-14-medium-acrom font-[number:var(--manager-acrom-ph-14-medium-acrom-font-weight)] tracking-[var(--manager-acrom-ph-14-medium-acrom-letter-spacing)] [font-style:var(--manager-acrom-ph-14-medium-acrom-font-style)]">
                Туда
            </div>
        </div>
    );
}


export const VisaDepartureDate = ({ entry_date, departure_date }: VisaProps) => {
    return (
        <div className="w-1/4 items-end justify-center gap-1 inline-flex flex-col">
            <div
                className="w-fit text-right whitespace-nowrap relative mt-[-1.00px] font-manager-acrom-ph1-16-medium-acrom font-[number:var(--manager-acrom-ph1-16-medium-acrom-font-weight)] text-black text-[length:var(--manager-acrom-ph1-16-medium-acrom-font-size)] tracking-[var(--manager-acrom-ph1-16-medium-acrom-letter-spacing)] leading-[var(--manager-acrom-ph1-16-medium-acrom-line-height)] [font-style:var(--manager-acrom-ph1-16-medium-acrom-font-style)]">
                {departure_date ? new Date(departure_date).toLocaleDateString() : '-'}
            </div>
            <div
                className="w-fit text-[#949494] text-[length:var(--manager-acrom-ph-14-medium-acrom-font-size)] text-right leading-[var(--manager-acrom-ph-14-medium-acrom-line-height)] whitespace-nowrap relative font-manager-acrom-ph-14-medium-acrom font-[number:var(--manager-acrom-ph-14-medium-acrom-font-weight)] tracking-[var(--manager-acrom-ph-14-medium-acrom-letter-spacing)] [font-style:var(--manager-acrom-ph-14-medium-acrom-font-style)]">
                Обратно
            </div>
        </div>
    );
}

export const VisaComments = ({ comment }: VisaProps) => {
    return (
        <div className="flex flex-col w-full p-5 items-start gap-1 relative flex-[0_0_auto]">
            <div
                className="w-full text-[#949494] text-[length:var(--client-acrom-ph1-16-medium-acrom-font-size)] leading-[var(--client-acrom-ph1-16-medium-acrom-line-height)] relative font-client-acrom-ph1-16-medium-acrom font-[number:var(--client-acrom-ph1-16-medium-acrom-font-weight)] tracking-[var(--client-acrom-ph1-16-medium-acrom-letter-spacing)] [font-style:var(--client-acrom-ph1-16-medium-acrom-font-style)]">
                Комментарий
            </div>
            <p className="w-full text-black text-[length:var(--manager-acrom-ph1-16-medium-acrom-font-size)] leading-[var(--manager-acrom-ph1-16-medium-acrom-line-height)] relative font-manager-acrom-ph1-16-medium-acrom font-[number:var(--manager-acrom-ph1-16-medium-acrom-font-weight)] tracking-[var(--manager-acrom-ph1-16-medium-acrom-letter-spacing)] [font-style:var(--manager-acrom-ph1-16-medium-acrom-font-style)]">
                {comment}
            </p>
        </div>
    );
}


export const VisaCountryEdit = ({ country, onChange }: VisaEditProps) => {

    return (
        <div className="px-5 w-1/2 mb-5 inline-flex flex-col items-start gap-2 relative flex-[0_0_auto]">
            <div
                className="w-full text-[#949494] text-[length:var(--manager-acrom-ph-14-medium-acrom-font-size)] leading-[var(--manager-acrom-ph-14-medium-acrom-line-height)] relative font-manager-acrom-ph-14-medium-acrom font-[number:var(--manager-acrom-ph-14-medium-acrom-font-weight)] tracking-[var(--manager-acrom-ph-14-medium-acrom-letter-spacing)] [font-style:var(--manager-acrom-ph-14-medium-acrom-font-style)]">
                Страна
            </div>
            <SelectDropdown
                fetchDataFunc={useSelectorsCountriesQuery}
                onChange={onChange}
                selected={country}
            />
        </div>
    );
}

export const VisaEntryDateEdit = ({ entry_date, onChange }: VisaEditProps) => {
    return (
        <div className="w-[49%] inline-flex flex-col items-start gap-2 px-5 flex-[0_0_auto]">
            <label
                className="w-full text-[#949494] text-[length:var(--manager-acrom-ph-14-medium-acrom-font-size)] leading-[var(--manager-acrom-ph-14-medium-acrom-line-height)] relative font-manager-acrom-ph-14-medium-acrom font-[number:var(--manager-acrom-ph-14-medium-acrom-font-weight)] tracking-[var(--manager-acrom-ph-14-medium-acrom-letter-spacing)] [font-style:var(--manager-acrom-ph-14-medium-acrom-font-style)]">
                Туда
            </label>
            <Datepicker date={entry_date} onDateChange={onChange} />
        </div>
    );
}

export const VisaDepartureDateEdit = ({ onChange, departure_date }: VisaEditProps) => {
    return (
        <div className="w-[49%] inline-flex flex-col items-start gap-2 px-5  flex-[0_0_auto]">
            <label
                className=" text-[#949494] text-[length:var(--manager-acrom-ph-14-medium-acrom-font-size)] leading-[var(--manager-acrom-ph-14-medium-acrom-line-height)] relative font-manager-acrom-ph-14-medium-acrom font-[number:var(--manager-acrom-ph-14-medium-acrom-font-weight)] tracking-[var(--manager-acrom-ph-14-medium-acrom-letter-spacing)] [font-style:var(--manager-acrom-ph-14-medium-acrom-font-style)]">
                Обратно
            </label>
            <Datepicker date={departure_date} onDateChange={onChange} />
        </div>
    );
}

export const VisaCommentsEdit = ({ comment, onChange }: VisaEditProps) => {
    const [text, setComment] = useState<string>(comment || '');

    const handleChange = (e: ChangeEvent<HTMLTextAreaElement>) => {
        if (e.target.value.length <= 1000) {
            setComment(e.target.value);
            onChange(e.target.value)
        }
    };
    return (
        <div className="px-5 w-full inline-flex flex-col mb-5 items-start gap-2 relative flex-[0_0_auto]">
            <div
                className="w-full text-[#949494] text-[length:var(--manager-acrom-ph-14-medium-acrom-font-size)] leading-[var(--manager-acrom-ph-14-medium-acrom-line-height)] relative font-manager-acrom-ph-14-medium-acrom font-[number:var(--manager-acrom-ph-14-medium-acrom-font-weight)] tracking-[var(--manager-acrom-ph-14-medium-acrom-letter-spacing)] [font-style:var(--manager-acrom-ph-14-medium-acrom-font-style)]">
                Комментарий
            </div>
            <div
                className="flex w-full items-start gap-2.5 px-4 py-3.5 flex-[0_0_auto] bg-[#f2f2f2] rounded-lg overflow-hidden">
                <TextareaCount max={1000} text={text} handleChange={handleChange} placeholder={''} />
            </div>
        </div>
    );
}